import React from 'react';
import { TreeSelect } from 'antd';
import { api } from 'react-structure-admin';
import removeAccents from 'util/removeAccents';
import display from 'constants/display';

const { TreeNode } = TreeSelect;

export default class RemoteSelectTree extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataSource: [],
      filterText: ''
    };

    this.handleLoadData();
  }

  handleLoadData = async (treeNode) => {
    const { dataSource } = this.state;
    const { params, resource } = this.props;
    let response;

    if (dataSource.length === 0 && !treeNode) {
      response = await api.fetch(`${resource}/tree`, params);
    }

    if (response && !response.errors) {
      this.setState({ dataSource: response.data.result });
    }
  };

  handleChange = (value) => {
    const { onChange, onChangeSelect, multiple, treeCheckable } = this.props;
    const { dataSource } = this.state;
    let data = [];

    this.filterNode(dataSource, data, value);

    if (!multiple && !treeCheckable) {
      data = data.length === 1 ? data[0] : undefined;
    }

    if (onChange) {
      onChange(data);
    }

    if (onChangeSelect) {
      onChangeSelect(data);
    }
  };

  filterNode = (items = [], data = [], indexes = []) => {
    for (let i = 0; i < items.length; i += 1) {
      const item = items[i];

      if (Array.isArray(indexes) && indexes.includes(item.id)) {
        data.push(this.normalizeItem(item));
      } else if (!Array.isArray(indexes) && indexes === item.id) {
        data.push(this.normalizeItem(item));
      }

      const subItems = this.getSubItems(item);

      for (let j = 0; j < subItems.length; j += 1) {
        this.filterNode([subItems[j]], data, indexes);
      }
    }
  };

  handleSearch = (filterText) => {
    this.setState({ filterText });
  };

  normalizeString = (text) => {
    return removeAccents(text).toLowerCase();
  };

  handleFilterTreeNode = (inputValue, { props }) => {
    const { onFilterTreeNode } = this.props;
    const title = this.getTitle(props.node);

    if (onFilterTreeNode) {
      return onFilterTreeNode(this.normalizeString(inputValue), props.node);
    }

    return this.normalizeString(title).includes(
      this.normalizeString(inputValue)
    );
  };

  getTitle = (node) => {
    const { getTitle } = this.props;

    if (getTitle) {
      return getTitle(node);
    }

    return node?.title || node?.description;
  };

  getSubItems = (node) => {
    const { getSubItems } = this.props;

    if (getSubItems) {
      return getSubItems(node);
    }

    return node?.subItems || [];
  };

  normalizeItem = (node) => {
    const { normalizeItem } = this.props;

    if (normalizeItem) {
      return normalizeItem(node);
    }

    return node;
  };

  handleDisabled = (node) => {
    const { onDisabled } = this.props;

    if (onDisabled) {
      return onDisabled(node);
    }

    return false;
  };

  renderChildren = (node) => {
    const { filterText } = this.state;
    const { id, type } = node;

    let title = this.getTitle(node);

    const index = this.normalizeString(title).indexOf(
      this.normalizeString(filterText)
    );

    const beforeStr = title.substr(0, index);
    const afterStr = title.substr(index + filterText.length);

    if (index > -1) {
      title = (
        <>
          <span>
            {beforeStr}
            <span style={{ color: 'red' }}>
              {title.substr(index, filterText.length)}
            </span>
            {afterStr}
          </span>
          {type ? (
            <span className="gx-text-grey">{` / ${display[type]}`}</span>
          ) : null}
        </>
      );
    }

    const items = this.getSubItems(node) ?? [];

    return (
      <TreeNode
        key={id}
        value={id}
        title={title}
        disabled={this.handleDisabled(node)}
        item={this.normalizeItem(node)}
        isLeaf={items?.length === 0}
        node={node}
      >
        {items.map((c) => this.renderChildren(c))}
      </TreeNode>
    );
  };

  render() {
    const { dataSource } = this.state;
    const {
      className,
      maxTagCount,
      placeholder,
      style,
      multiple,
      maxTagPlaceholder,
      value,
      dropdownMatchSelectWidth,
      disabled,
      allowClear,
      onSelect,
      width
    } = this.props;

    const tempValue = multiple ? value?.map((c) => c.id) ?? [] : value?.id;

    return (
      <TreeSelect
        className={className}
        disabled={disabled}
        maxTagCount={maxTagCount}
        style={style || { width: width ?? '100%' }}
        value={tempValue}
        multiple={multiple}
        onSearch={this.handleSearch}
        allowClear={allowClear}
        dropdownMatchSelectWidth={dropdownMatchSelectWidth ?? 400}
        onBlur={() => this.setState({ filterText: '' })}
        filterTreeNode={this.handleFilterTreeNode}
        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
        placeholder={placeholder}
        maxTagPlaceholder={maxTagPlaceholder}
        showSearch
        onChange={this.handleChange}
        onSelect={onSelect}
      >
        {dataSource.map((c) => this.renderChildren(c))}
      </TreeSelect>
    );
  }
}
